import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Отзывы о нас',
  reviews: [
    {
      name: 'Сердюков Данил Александрович',
      text: 'У нас хозяйство сейчас 1,8 тыс. гектаров, сеем в основном озимую пшеницу, яровой ячмень. Урожай неплохой планирую, по возможности буду увеличивать земельный банк и парк техники, поэтому возможно буду привлекать и субсидированные кредиты.',
      location: 'Волгоградская область',
      farm: '1 800 Га',
    },
    {
      name: 'Феликс Гланц-Калустов',
      text: 'Мы уже несколько лет сотрудничаем с платформой Поле.РФ, было совершено множество сделок в разных регионах страны. Поле.РФ выступает не только своего рода маркетплейсом, но и гарантом качества и стабильности, а также дает возможность получить финансирование и топливо в рассрочку.',
      location: 'Волгоградская область',
    },
    {
      name: 'Наталья, бухгалтер ООО «Промхим»',
      text: 'Приобретали дизельное топливо в рассрочку через поле.рф. Оперативно получили предложения от нескольких поставщиков и выбрали наиболее выгодное. Рассрочку одобрили и получили средства на оплату заказа в течение всего нескольких часов. Сделку полностью «под ключ» получилось провести меньше чем за 1 рабочий день.',
      location: 'Удмуртская Республика',
    },
    {
      name: 'ГКФХ Борисков Виктор Васильевич',
      text: 'Приобретали селитру и семена в рассрочку через поле.рф. Сделку от и до сопровождал личный менеджер от поле.рф. Оперативно помогли зарегистрировать землю в Росреестре для официального оформления в залог - в течение трёх дней получил деньги и оплатил заказ. Менеджер контролировал сроки и условия отгрузки товара поставщиком. Спасибо, продолжаем работать, с вами меньше головной боли!',
      location: 'Саратовская область',
      farm: ' 1 500 Га',
    },
    {
      name: 'Пётр Писклюков',
      text: 'Взаимодействие с платформой понравилось, трудностей не возникло, всё было понятно. Общение с менеджером — это очень удобно: можно что-то спросить или уточнить.',
      location: 'Воронежская область',
      farm: ' 500 га',
    },
    {
      name: 'Василий Еманов',
      text: 'Удобно, быстро, ещё и в кредит можно купить. Всё понравилось, всегда интересно новое. Мы планируем все заявки прогонять через поле.рф, мы за сотрудничество.',
      location: 'Волгоградская область',
      farm: ' 43 400 га',
    },
  ],
} satisfies TMessages
